import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { SKmkMACacheViewModel } from './sKmkMACacheViewModel';

export class SKmkMACacheContainer extends MasterDataContainer<SKmkMACacheViewModel> {
    constructor(models: Array<SKmkMACacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
